
import { useEffect, useState } from 'react';
import { Pagination, PaginationItem } from '@mui/material';

const JiraIssuesListPagination = ({ setPageNum, pageNum, pageSize, totalRecords }) => {

    const [pageCount, setPageCount] = useState(Math.ceil(totalRecords / pageSize));
    useEffect(() => {
        setPageCount(Math.ceil(totalRecords / pageSize));
    }, [totalRecords, pageSize]);
    return (
        pageCount > 0 && (
            <Pagination
              page={pageNum + 1} // MUI Pagination is 1-based, so +1
              count={pageCount}
              showFirstButton
              showLastButton
              onChange={(_, value) => setPageNum(value - 1)} // convert back to 0-based
              renderItem={(item) => {
                const isDisabled =
                  (item.type === 'first' && pageNum === 0) ||
                  (item.type === 'previous' && pageNum === 0) ||
                  (item.type === 'next' && pageNum + 1 === pageCount) ||
                  (item.type === 'last' && pageNum + 1 === pageCount);
          
                const handleClick = () => {
                  if (isDisabled) return;
          
                  switch (item.type) {
                    case 'first':
                      setPageNum(0);
                      break;
                    case 'previous':
                      setPageNum(pageNum - 1);
                      break;
                    case 'next':
                      setPageNum(pageNum + 1);
                      break;
                    case 'last':
                      setPageNum(pageCount - 1);
                      break;
                    default:
                      setPageNum(item.page - 1); // convert back to 0-based
                  }
                };
          
                return (
                  <PaginationItem
                    {...item}
                    component="a"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      handleClick();
                    }}
                    disabled={isDisabled}
                    selected={pageNum === item.page - 1}
                  />
                );
              }}
              sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}
            />
        )
    )
}

export default JiraIssuesListPagination;